<template>
   <div class="container-fluid pr-0 pl-0 min-hex">
      <section class="multi_product_wrap">
           <span class="back_arrow" @click="go_back()"><i class="fas fa-angle-double-left"></i> {{get_local_string.string_86}}</span>
       <form @submit.prevent="sub()">
        <div class="pizza_hall">
            <a class="pizza_1 pizza_preview" href="#modal-HalHal_1" uk-toggle>
                <p class="title_prev">{{get_local_string.string_94}}</p>
                <ion-icon name="create-outline"></ion-icon>
                <img id="pizza1" :src="src_pizza_1" alt="">
                <p class="pizza_name1">{{pizza_name_1}}</p>
            </a>
            
            <a class="pizza_2 pizza_preview" href="#modal-HalHal_2"  uk-toggle>
                 <p class="title_prev">{{get_local_string.string_95}}</p>
                 <ion-icon name="create-outline"></ion-icon>
                  <img :src="src_pizza_2" alt="">
                  <p class="pizza_name2">{{pizza_name_2}}</p>
            </a>

        </div>
           <div class="step-navigator">
                    <template v-if="all_data_cart.status==402">
                     <b-button outlined class="submit_tulbid" :disabled="true" type="is-success" ><i class="fas fa-shopping-basket mr-1"  aria-hidden="true"></i>{{get_local_string.string_87}}</b-button>
                </template>
                <template v-else>
                     <b-button outlined class="submit_tulbid" :disabled="disabled_halhal"  :loading="load_half" type="is-success" native-type="submit"><i class="fas fa-shopping-basket"  aria-hidden="true"></i> {{get_local_string.string_88}} </b-button>
                </template>
                </div>
        </form>
    </section>

    <!-- Modal Hal Hla Pizza Half -->
    <div id="modal-HalHal_1" class="uk-modal-container" uk-modal>
    <div class="uk-modal-dialog uk-modal-body">
        <button class="uk-modal-close-default" type="button" uk-close></button>
        <h2 class="uk-modal-title">{{get_local_string.string_94}}</h2>
        <div class="boxs_pizza_optoin">
            <div class="row">
                <div class="col-xl-3 col-lg-4 col-md-6 col-12" v-for="half_box in get_box_details.halfFoodList" :key="half_box.id">
                     <b-checkbox class="check_halhal_wrap"  v-model="pizza_half_one" type="is-success"
                            :native-value="half_box" @change.native="on_select_pizza_one(half_box,$event)"
                            :disabled="pizza_half_one.length >= max_pizza && pizza_half_one.indexOf(half_box) == -1"
                            >
                        <div class="box_opt_hal">
                       <div class="opt_hal_img">
                          <template v-if="half_box.image">
                                <img :src="half_box.image" :alt="half_box.name">
                            </template>
                            <template v-else>
                                <img :src="get_setting_app.logo" alt="logo">
                            </template>
                       </div>
                       <div class="opt_hal_title">
                        <p>{{half_box.name}}</p>
                       </div>
                    </div>
                        </b-checkbox>
                </div>
            </div>
        </div>
    </div>
</div>
<div id="modal-HalHal_2" class="uk-modal-container" uk-modal>
    <div class="uk-modal-dialog uk-modal-body">
        <button class="uk-modal-close-default" type="button" uk-close></button>
        <h2 class="uk-modal-title">{{get_local_string.string_95}}</h2>
        <div class="boxs_pizza_optoin">
            <div class="row">
                <div class="col-xl-3 col-lg-4 col-md-6 col-12" v-for="half_box in get_box_details.halfFoodList" :key="half_box.id">
                     <b-checkbox class="check_halhal_wrap"  v-model="pizza_half_two" type="is-success"
                            :native-value="half_box" @change.native="on_select_pizza_two(half_box,$event)"
                            :disabled="pizza_half_two.length >= max_pizza && pizza_half_two.indexOf(half_box) == -1"
                            >
                        <div class="box_opt_hal">
                       <div class="opt_hal_img">
                          <template v-if="half_box.image">
                                <img :src="half_box.image" :alt="half_box.name">
                            </template>
                            <template v-else>
                                <img :src="get_setting_app.logo" alt="logo">
                            </template>
                       </div>
                       <div class="opt_hal_title">
                        <p>{{half_box.name}}</p>
                       </div>
                    </div>
                        </b-checkbox>
                </div>
            </div>
        </div>
    </div>
</div>
 <b-notification :closable="false">
            <b-loading :is-full-page="isFullPage" v-model="isLoading" :can-cancel="false"></b-loading>
        </b-notification>
   </div>
</template>

<script>
 import $ from 'jquery';
import { mapActions, mapGetters, mapState } from 'vuex';
export default {
   name:'halfhalf-tilpase',
   data(){
       return{
        pizza_half_one:[],
        pizza_half_two:[],
        src_pizza_1:'',
        src_pizza_2:'',
        pizza_name_1:'',
        pizza_name_2:'',
        isLoading: true,
        isFullPage: true,
        max_pizza:1,
        disabled_halhal:true,
        load_half:false,
        // half half object to backend
        food_id:null,
        default:0,
        qty:1,
        food_1:null,
        food_2:null,
        platform:'web',
       }
   },
   computed:{
       ...mapGetters({
            get_box_details: 'get_box_details',
            all_data_cart:'all_data_cart',
            get_setting_app:'get_setting_app',
            get_local_string:'get_local_string'
       }),
       ...mapState({
                custom_pizza: 'custom_pizza'
       }),
       getextra_prices(){
                return this.extra_prices
            }
   },
   methods:{
       ...mapActions({
            box_details: 'box_details',
            half_product_add:'half_product_add'
            }),
            on_select_pizza_one(pizza_object,event){
                // cehecked pizza one
              if(event.target.checked){
                this.food_1 = pizza_object.id;
                this.src_pizza_1 = pizza_object.image;
                this.pizza_name_1 = pizza_object.name;
                 $('.pizza_1').removeClass('emptyPizza');
                 this.uk.modal($('#modal-HalHal_1')).hide();
                }else{
                    this.food_1 = null;
                    this.pizza_name_1 = '';
                    if(this.pizza_half_one.length === 0){
                       $('.pizza_1').addClass('emptyPizza');
                    }
                }
                // 
                if(this.pizza_half_one.length == this.max_pizza && this.pizza_half_two.length == this.max_pizza){
                    this.disabled_halhal = false;
                }else{
                    this.disabled_halhal = true;
                }
            },
            on_select_pizza_two(pizza_object,event){
                // cehecked pizza one
              if(event.target.checked){
                this.food_2 = pizza_object.id;
                this.src_pizza_2 = pizza_object.image;
                this.pizza_name_2 = pizza_object.name;
                $('.pizza_2').removeClass('emptyPizza');
                  this.uk.modal($('#modal-HalHal_2')).hide();
                }else{
                    this.food_2 = null;
                    this.pizza_name_2 = '';
                    if(this.pizza_half_two.length === 0){
                       $('.pizza_2').addClass('emptyPizza');
                    }
                }
                // 
                if(this.pizza_half_one.length == this.max_pizza && this.pizza_half_two.length == this.max_pizza){
                    this.disabled_halhal = false;
                }else{
                    this.disabled_halhal = true;
                }
            },
             go_back(){
                this.$router.go(-1);
            },
            close_modal_1(){
                  this.uk.modal($('#modal-HalHal_1')).hide();
            },
            close_modal_2(){
                 this.uk.modal($('#modal-HalHal_2')).hide();
            },
                sub(){
                this.load_half = true;
                    let half_product_object ={
                    'food_id': this.food_id,
                    'default': this.default,
                    'qty':     this.qty,
                    'food_1':this.food_1,
                    'food_2':this.food_2,
                    'platform':this.platform
                }
                   this.half_product_add(half_product_object).then(()=>{
                       this.load_half = false;
                       this.$router.go(-1);
                      this.uk.offcanvas($('#offcanvas-flip')).show();
                })
            },
            
   },
   mounted(){
             document.documentElement.classList.add('halhal');
        // get details this item when pass id to thos func => box_details (id)
        console.log(this.get_box_details , 'ok');
        this.box_details(this.$route.params.id).then(()=>{
            this.food_id = this.get_box_details.id;
            this.src_pizza_1 = this.get_box_details.halfFoodList[0].image;
            this.src_pizza_2 = this.get_box_details.halfFoodList[0].image;
              this.close_modal_1();
              this.close_modal_2();
              if(this.pizza_half_one.length === 0 && this.pizza_half_two.length === 0){
                 $('.pizza_1').addClass('emptyPizza');
                 $('.pizza_2').addClass('emptyPizza');
              }
             this.isLoading = false;
        });
   },
    destroyed(){
     document.documentElement.classList.remove('halhal');
    }
}
</script>
<style lang="scss" scoped>
.pizza_hall{
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    text-align: center;
    top: 50%;
    transform: translate(0px, -50%);
    .title_prev{
        font-size: 23px;
    padding-bottom: 43px;
    letter-spacing: 5px;
    font-weight: 600;
    }
    .pizza_preview.pizza_1{
        color: white;
        cursor: pointer;
       position: relative;
        width: 550px;
        height: 400px;
        text-align: left;
        overflow: hidden;
        &:hover{
            img{
                transform: scale(1.06);
            }
            
        }
        ion-icon{  
    font-size: 60px;
    position: absolute;
    right: 40%;
    z-index: 2;
    top: 38%;
     animation: heartbeat 1.5s infinite;
        }
        img{
           width: 100%;
            position: absolute;
            right: -50%;
            height: 70%;
            -o-object-fit: contain;
            object-fit: contain;
            transition: 0.2s ease-in-out;
            bottom: 0;
            top: 0;
            margin-top: auto;
            margin-bottom: auto;
        }
    }
    // pizza 2
     .pizza_preview.pizza_2{
         color: white;
    cursor: pointer;
        position: relative;
    width: 550px;
    height: 400px;
    text-align: right;
    overflow: hidden;
    border-left: 1px solid #ffffffb5;
     &:hover{
            img{
                transform: scale(1.06);
            }
        }
             ion-icon{  
    font-size: 60px;
    position: absolute;
    left: 40%;
    z-index: 2;
    top: 38%;
    animation: heartbeat 1.5s infinite;
        }
        img{
            width: 100%;
            position: absolute;
            left: -50%;
            height: 70%;
            -o-object-fit: contain;
            object-fit: contain;
            transition: 0.2s ease-in-out;
            bottom: 0;
            top: 0;
            margin-top: auto;
            margin-bottom: auto;
        }
    }
    .emptyPizza{
        img{
        filter: brightness(0.5);
        }
    }
    .pizza_name1{
        position: absolute;
    bottom: 0;
    right: 20px;
    font-size: 20px;
    font-weight: 600;
    }
    .pizza_name2{
    position: absolute;
    bottom: 0;
    left: 20px;
    font-size: 20px;
    font-weight: 600;
    }
}
.box_opt_hal{
    text-align: center;
    background-color: #ededed;
    padding: 20px;
    border-radius: 0px 14px 14px 14px;
    margin-bottom: 40px;
    border: 1px solid gainsboro;
    img{
        width: 200px;
        height: 150px;
        object-fit: contain;
    }
    .opt_hal_title{
        padding-top: 20px;
        font-size: 16px;
        font-weight: 500;
        color: black;
    }
}
   @media(max-width:767px){
    .pizza_hall .title_prev{
    font-size: 20px;
    letter-spacing: 5px;
    font-weight: 600;
    padding: 0px 20px;
}
.pizza_hall .pizza_preview.pizza_2 ion-icon {
    font-size: 50px;
    position: absolute;
    left: 60%;
    z-index: 2;
    top: 42%;
}
.pizza_hall .pizza_preview.pizza_1 ion-icon {
    font-size: 50px;
    position: absolute;
    right: 60%;
    z-index: 2;
    top: 42%;
}
  .pizza_name1{
    bottom: 40px !important;
    font-size: 18px;
    width: 70%;
    text-align: center;
    }
    .pizza_name2{
    bottom: 40px !important;
    font-size: 18px;
     width: 70%;
    text-align: center;
    }
 .pizza_hall .pizza_preview.pizza_1, .pizza_hall .pizza_preview.pizza_2{
    img{
        height: 80% !important;
    }
 }
   }

   @keyframes heartbeat
{
  0%
  {
    transform: scale( .75);
  }
  
  20%
  {
    transform: scale( 1);
  }
  
  40%
  {
    transform: scale( .75);
  }
  
  60%
  {
    transform: scale( 1);
  }
  80% {
    transform: scale( .75);
  }
  
  100%
  {
    transform: scale( .75);
  }
}
.step-navigator {
    position: sticky;
    bottom: 0px;
    text-align: center;
    -webkit-backdrop-filter: blur(4px);
    backdrop-filter: blur(4px);
    background-color: #101010 !important;
    padding: 14px;
}
</style>